<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1Box max-w-1400">
        <!-- <img :src="importedImg11" alt="" class="imgItem1" /> -->
         <p>Hang ổ của bạn</p>
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(image, index) in images"
              :class="{zoom: zoomIndex === index}"
              :key="index"
            >
              <img :src="image.src" :alt="image.alt" />
            </div>
          </div>
          <!-- 如果需要分页 -->
          <div class="swiper-pagination"></div>
          <!-- 导航按钮 -->
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </div>
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2Box max-w-1400">
        <img :src="importedImg2" alt="" class="imgItem2" />
      </div>
    </div>
    <div class="imgBox3 min-w-1400">
      <div class="img3Box max-w-1400">
        <img :src="importedImg3" alt="" class="imgItem3" />
      </div>
    </div>
    <div class="imgBox4 min-w-1400">
      <div class="img4Box max-w-1400">
        <img :src="importedImg4" alt="" class="imgItem4" />
      </div>
    </div>
    <div class="imgBox5 min-w-1400">
      <div class="img5Box max-w-1400">
        <img :src="importedImg5" alt="" class="imgItem5" />
      </div>
    </div>
    <div class="imgBox6 min-w-1400">
      <div class="img6Box max-w-1400">
        <img :src="importedImg6" alt="" class="imgItem6" />
      </div>
    </div>
    <div class="imgBox7 min-w-1400">
      <div class="img7Box max-w-1400">
        <img :src="importedImg7" alt="" class="imgItem7" />
      </div>
    </div>
    <div class="imgBox8 min-w-1400">
      <div class="img8Box max-w-1400">
        <img :src="importedImg8" alt="" class="imgItem8" />
      </div>
    </div>
    <div class="imgBox9 min-w-1400">
      <div class="img9Box max-w-1400">
        <img :src="importedImg9" alt="" class="imgItem9" />
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";
// import Swiper from "swiper";
import Swiper from "swiper/bundle";
// import styles bundle
import "swiper/css/bundle";

import importedImg11 from "@/page/easylifetmdv/components/img/1_1_1.png";
import importedImg12 from "@/page/easylifetmdv/components/img/1_1_2.png";
import importedImg13 from "@/page/easylifetmdv/components/img/1_1_3.png";
import importedImg14 from "@/page/easylifetmdv/components/img/1_1_4.png";
import importedImg15 from "@/page/easylifetmdv/components/img/1_1_5.png";
import importedImg2 from "@/page/easylifetmdv/components/img/1_2.png";
import importedImg3 from "@/page/easylifetmdv/components/img/1_3.png";
import importedImg4 from "@/page/easylifetmdv/components/img/1_4.png";
import importedImg5 from "@/page/easylifetmdv/components/img/1_5.png";
import importedImg6 from "@/page/easylifetmdv/components/img/1_6.png";
import importedImg7 from "@/page/easylifetmdv/components/img/1_7.png";
import importedImg8 from "@/page/easylifetmdv/components/img/1_8.png";
import importedImg9 from "@/page/easylifetmdv/components/img/1_9.png";

export default {
  data() {
    return {
      importedImg11: importedImg11,
      importedImg12: importedImg12,
      importedImg13: importedImg13,
      importedImg14: importedImg14,
      importedImg15: importedImg15,
      importedImg2: importedImg2,
      importedImg3: importedImg3,
      importedImg4: importedImg4,
      importedImg5: importedImg5,
      importedImg6: importedImg6,
      importedImg7: importedImg7,
      importedImg8: importedImg8,
      importedImg9: importedImg9,
      images: [
        // { src: importedImg11, alt: "Image 1" },
        { src: importedImg12, alt: "Image 2" },
        { src: importedImg13, alt: "Image 3" },
        { src: importedImg14, alt: "Image 4" },
        // { src: importedImg15, alt: "Image 5" },
        // { src: importedImg13, alt: "Image 3" },
      ],
      altText: "图片",
      // zoomIndex: null,
    };
  },
  mounted() {
    // 初始化 Swiper
    new Swiper(".swiper-container", {
      loop: true, // 循环模式
      autoplay: {
        delay: 3000, // 每3秒切换一次
        disableOnInteraction: false,
      },
      preloadImages: true,
      slidesPerView: 1, // 一次显示3张图片
      spaceBetween: 150, // 图片之间的间距
      centeredSlides: true,
      speed: 3000,
      pagination: {
        el: ".swiper-pagination", // 分页器
        clickable: true, // 可以点击分页器跳转
      },
      navigation: {
        nextEl: ".swiper-button-next", // 下一张按钮
        prevEl: ".swiper-button-prev", // 上一张按钮
      },
      // scrollbar: {
      //   el: ".swiper-scrollbar", // 滚动条
      // },
      // on: {
      //   slideChange: function () {
      //     console.log("当前滑动的索引是: ", this.realIndex);
      //     this.zoomIndex = this.realIndex;
      //     // 在这里执行你想做的操作
      //   },
      // },
    });
  },
  created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.swiper-container {
  position: relative;
  width: 100%;
  /* height: 500px; */
}
.swiper-slide{
  transition: transform 5s linear;
  display: flex;
  align-items: center;
}


.swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper-pagination {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center; /* 确保分页器居中 */
}
/* .swiper-slide-active img{
  transition: transform 1s linear;
}

.swiper-slide-active img {
  transform: scale(1.2); 
} */

.img1Box p{
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  color: #333333;
  font-size: 40px;
 font-style: normal;
 font-weight: 600;
}

.imgBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}
img {
  display: block;
}
.imgBox1,
.imgBox2,
.imgBox3,
.imgBox4,
.imgBox5,
.imgBox6,
.imgBox7,
.imgBox8,
.imgBox9 {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.img1Box,
.img2Box,
.img3Box,
.img4Box,
.img5Box,
.img6Box,
.img7Box,
.img8Box,
.img9Box {
  margin: 0;
  overflow: hidden;
  width: 100%;
  background-color: "";
}

.imgItem1,
.imgItem2,
.imgItem3,
.imgItem4,
.imgItem5,
.imgItem6,
.imgItem7,
.imgItem8,
.imgItem9 {
  width: 100%;
  margin: 0;
}

.img2Box,
.img4Box,
.img6Box,
.img8Box {
  padding: 200px;
}
.img3Box {
  padding: 0 200px;
}
</style>
